/**
 * <QrCode 
 *	/>
 *
 * This is a wrapper component to display a png QR code instead of HTML canvas 
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import QrCodeReact from 'qrcode.react';
import uniqid from 'uniqid';
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import domtoimage from 'dom-to-image'
import './QrCode.scss';
import locale from './locale'

class QrCode extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
    this.state = {
      showCanvas: true,
    }
  }

  componentWillMount() {
    this.canvasID = uniqid('canvas-');
  }
  
  componentDidMount() {
    // when component is mounted and the canvas is generated, convert the image
    if (typeof this.ref.firstChild.toBlob !== 'function') {
      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
          var canvas = this;
          setTimeout(function() {

            var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
                len = binStr.length,
                arr = new Uint8Array(len);

            for (var i = 0; i < len; i++ ) {
              arr[i] = binStr.charCodeAt(i);
            }
            callback( new Blob( [arr], {type: type || 'image/png'} ) );
          });
        }
      });
    }
    this.ref.firstChild.toBlob((blob)=> {
      const filename = 'qrcode.png';
      const contentType = 'application/octet-stream';
      const urlCreator = window.URL || window.webkitURL;
      const file = new File([blob], filename, {type: contentType, lastModified: Date.now()});
      const imageUrl = urlCreator.createObjectURL( file )

      let img = new Image();
      img.src = imageUrl;
      img.setAttribute('download', 'qrcode.png');
      this.targetRef.appendChild(img);
      this.setState({
        showCanvas: false,
      });
      if(this.props.showDownloadBtn) {
        this.targetRef.appendChild(document.createElement("br"));
        var downloadBtn = document.createElement('a');
        downloadBtn.textContent =__('Download QR Code', locale);
        downloadBtn.className = 'downloadBtn'
        downloadBtn.addEventListener('click', function(ev) {
          downloadBtn.href = imageUrl;
          downloadBtn.download = "qrcode.png";
        }, false);
        
        this.targetRef.appendChild(downloadBtn);
      }
    });

    return;

    domtoimage.toBlob(this.ref.firstChild)
      .then((blob)=>{

      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
  }
  render() {
    const {
      showCanvas,
    } = this.state;

    return (
      <div className='QrCode'>
        <div className='QrCodeCanvas' style={{ display: showCanvas === true ? 'block' : 'none' }} ref={(r)=>{ if (r) this.ref = r; }}>
          <QrCodeReact id={this.canvasID} {...this.props} /> 
        </div>
        <div className='QrCodeImage' style={{ display: showCanvas === true ? 'none' : 'block' }} ref={(r)=> { if (r) this.targetRef = r; }}></div>
      </div>
    )
  }
}

export default QrCode;



// WEBPACK FOOTER //
// ./src/components/UI/QrCode/index.js